<script lang="ts">
	import User from '$lib/components/User.svelte'
	import { Button } from '$lib/shadcn/ui/button/index.js'
	import GithubIcon from '$lib/svg/Github.svelte'
	import {
		BlocksIcon,
		BoxIcon,
		PyramidIcon,
		SparkleIcon,
	} from 'lucide-svelte'

	export let data
</script>

<svelte:head>
	<title>Scenery Scripts</title>
</svelte:head>

<!-- <section class="grid grid-cols-scripts gap-5 px-5"> -->
<section class="flex flex-wrap justify-center gap-5 px-5">
	{#each data.items as { name, description, path, user: { username } }}
		<a href={path} class="w-full md:max-w-sm">
			<div
				class="rounded-lg p-6 flex flex-col bg-[rgb(18,18,18)] hover:bg-zinc-900"
			>
				<div class="flex justify-between gap-4">
					<div class="w-10 h-10 mb-4 text-green-400">
						{#if name === 'Curves'}
							<SparkleIcon
								class="w-full h-full"
								strokeWidth="1"
							/>
						{:else if name === 'Upload'}
							<PyramidIcon
								class="w-full h-full"
								strokeWidth="1"
							/>
						{:else}
							<BoxIcon class="w-full h-full" strokeWidth="1" />
						{/if}
					</div>
				</div>
				<h3 class="font-semibold text-xl">
					{name}
				</h3>
				<p
					class="mt-2 mb-6 text-muted-foreground line-clamp-2 flex-grow"
				>
					{description}
				</p>

				<User size="s" {username} />
			</div>
		</a>
	{/each}
	<div
		class="w-full md:max-w-sm rounded-lg p-6 flex flex-col bg-[rgb(18,18,18)]"
	>
		<div class="w-10 h-10 mb-4">
			<BlocksIcon class="w-full h-full" strokeWidth="1" />
		</div>
		<h3 class="font-semibold text-xl">More coming</h3>
		<p class="mt-2 mb-6 text-muted-foreground line-clamp-2 flex-grow">
			We'll soon introduce more scripts by the community!
		</p>
	</div>
</section>
<section class="flex justify-center mt-16 px-5">
	<div class="border rounded-xl p-6 max-w-md">
		<h3 class="font-semibold text-xl mb-2">Want to contribute?</h3>
		<p class="text-muted-foreground">
			If you have any scripts that could benefit the community, apply
			below and explore our developer tools on GitHub!
		</p>
		<div class="flex gap-2 mt-6">
			<Button variant="secondary" href="/support">Apply Now</Button>
			<Button variant="ghost" href="https://github.com/scenery-io">
				<GithubIcon />
				<span class="ml-2">Developer Tools</span>
			</Button>
		</div>
	</div>
</section>
